'use client';
import React, { useState } from 'react';
import dynamic from 'next/dynamic';

const SalesChartInner = dynamic(() => import('./SalesChartInner'), { ssr: false });

const periods = ['7D', '30D', '90D', 'YTD'] as const;
type Period = typeof periods[number];

export default function SalesPerformanceChart() {
  const [activePeriod, setActivePeriod] = useState<Period>('30D');

  return (
    <div className="card-surface p-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
        <div>
          <h2 className="text-base font-semibold text-foreground">Sales Performance</h2>
          <p className="text-sm text-muted-foreground">Daily revenue with 7-day moving average</p>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-3 text-xs text-muted-foreground">
            <span className="flex items-center gap-1.5">
              <span className="w-3 h-0.5 bg-primary rounded inline-block" />
              Revenue
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-3 h-0.5 bg-warning rounded inline-block" />
              Target
            </span>
          </div>
          <div className="flex items-center bg-muted rounded-lg p-1">
            {periods.map((p) => (
              <button
                key={`period-${p}`}
                onClick={() => setActivePeriod(p)}
                className={`px-3 py-1 rounded-md text-xs font-semibold transition-all duration-150 btn-press ${
                  activePeriod === p
                    ? 'bg-card text-foreground shadow-card'
                    : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                {p}
              </button>
            ))}
          </div>
        </div>
      </div>
      <SalesChartInner period={activePeriod} />
    </div>
  );
}